import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import appNavigationNames from '../../utils/appNavigationNames';
import { useIsUserLoggedIn } from '../../hooks/useIsUserLoggedIn';
import { getIntl } from '../../utils/intl';
import TabNavigation from './TabNavigation';
import { SignUpScreen } from '../screens/Root/SignUpScreen';
import { SignInScreen } from '../screens/Root/SignInScreen';
import SharedReportScreen from '../screens/Root/SharedReportScreen';
import { getHeader, mobileHeaderConfigs } from '../v2BaseComponents/Header';
import { colors } from '../../utils/theme';
import RedirectScreen from '../screens/Root/RedirectScreen';
import WelcomeScreen from '../screens/Root/WelcomeScreen';

export type AppNavigatorOwnProps = {};

export type AppNavigatorProps = AppNavigatorOwnProps;

const intl = getIntl('RootAppNavigation', {
    faqs: 'FAQs',
    termsOfService: 'Terms of Service',
    login: 'Login',
    signup: 'Sign Up',
    welcome: 'Primary Record',
    app: 'Primary Record',
    sharedReport: 'Shared Report',
    about: 'About',
    dataSafety: 'Data Safety',
});

const Stack = createNativeStackNavigator();

const RootNavigation: React.FC<AppNavigatorProps> = ({}) => {
    const { isUserLoggedIn } = useIsUserLoggedIn();

    if (isUserLoggedIn === 'loading') return null;

    const initialRouteName = isUserLoggedIn ? appNavigationNames.root.app : appNavigationNames.root.welcome;

    /**
     * These routes cannot have params
     */
    return (
        <Stack.Navigator
            initialRouteName={initialRouteName}
            screenOptions={{
                contentStyle: {
                    backgroundColor: colors.Background,
                },
            }}
        >
            <Stack.Screen
                options={{
                    headerShown: false,
                }}
                name={appNavigationNames.root.welcome}
                component={WelcomeScreen}
            />
            <Stack.Screen
                options={{
                    headerShown: false,
                }}
                name={appNavigationNames.root.signup}
                component={SignUpScreen}
            />
            <Stack.Screen
                options={{
                    headerShown: false,
                    header: getHeader({ mobile: mobileHeaderConfigs.logo }),
                    headerTitle: intl('login'),
                }}
                name={appNavigationNames.root.login}
                component={SignInScreen}
            />
            <Stack.Screen
                options={{
                    headerShown: false,
                }}
                name={appNavigationNames.root.sharedReport}
                // @ts-expect-error TS2322
                component={SharedReportScreen}
            />
            <Stack.Screen
                options={{
                    headerShown: false,
                    headerTitle: intl('app'),
                }}
                name={appNavigationNames.root.app}
                component={TabNavigation}
            />
            <Stack.Screen
                options={{
                    headerShown: false,
                }}
                name={appNavigationNames.root.redirect}
                component={RedirectScreen}
            />
        </Stack.Navigator>
    );
};

export default React.memo(RootNavigation);
